import { css } from 'styled-components';

import { textSizes } from 'utils/style/theme';
import media from 'utils/style/media';

const fontSizeAdaptative = css`
  ${media.lessThan('small')`
    font-size: ${textSizes('M')};
  `};
`;

export { fontSizeAdaptative };
export default undefined;
